var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationEmptyContent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 240,
    viewBox: "0 0 327 240",
    width: 327,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "19.495903%",
    x2: "77.479035%",
    y1: "70.897978%",
    y2: "18.101149%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#919eab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919eab",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 140,
    rx: 12,
    width: 172
  }), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 132.520479c0 27.638106 10.1815403 52.823212 26.9359737 71.857174 19.2210583 21.843031 47.0935619 35.576174 78.1622963 35.622347 13.578251.01963 26.561505-2.591298 38.487224-7.357648 6.166205-2.465429 13.067742-2.182475 19.03991.738459 7.005358 3.42177 14.84987 5.340301 23.13329 5.340301 3.421771 0 6.772658-.329748 10.013996-.95561 9.252171-1.780344 17.671632-5.993216 24.586057-11.96011 4.345413-3.751518 9.910892-5.637147 15.598807-5.630567h.096661c18.795037 0 36.2533-5.821396 50.748033-15.797172 12.958194-8.906839 23.539979-21.130893 30.590445-35.483318 6.146872-12.507009 9.607307-26.635702 9.607307-41.589131 0-51.2870702-40.721149-92.8696204-90.945785-92.8696204-5.120127 0-10.136433.4416131-15.030302 1.2656163-12.958194-21.4211586-36.163084-35.7011999-62.634373-35.7011999-11.176066 0-21.771456 2.54512435-31.255611 7.10748458-9.019469 4.32473732-17.038685 10.47003182-23.598691 17.95917532-22.274804.3626492-42.871301 7.7933009-59.7288387 20.1942932-26.5357289 19.509208-43.8063993 51.3272837-43.8063993 87.2595259z",
    fill: "url(#a)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(51 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m139.604706 17.0504412c-2.184706 0-4.368824-.8311765-6.031177-2.4941177-3.325882-3.3258823-3.325882-8.73705877 0-12.06235289 3.324118-3.32470589 8.736471-3.32588236 12.061765 0 3.325882 3.32588235 3.325882 8.73705879 0 12.06235289-1.662353 1.6629412-3.84647 2.4941177-6.030588 2.4941177zm0-11.17117647c-.677647 0-1.355882.25764705-1.872353.77411764-1.031765 1.03176471-1.031765 2.71117647 0 3.74352943 1.032941 1.0317647 2.710588 1.0323529 3.743529 0 1.031765-1.03176472 1.031765-2.71117649 0-3.74352943-.515882-.51588235-1.194117-.77411764-1.871176-.77411764z",
    fill: "#c4cdd5",
    opacity: 0.545118
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.5517647 216.193971c-2.1841176 0-4.3688235-.831765-6.0311765-2.494118-3.3258823-3.325882-3.3258823-8.737059 0-12.062353 3.3247059-3.325294 8.7376471-3.325294 12.062353 0 3.3258823 3.325882 3.3258823 8.737059 0 12.062353-1.662353 1.662941-3.8470588 2.494118-6.0311765 2.494118zm0-11.171177c-.6776471 0-1.3558823.257647-1.8723529.774118-1.0317647 1.031764-1.0317647 2.711176 0 3.743529 1.0329411 1.032353 2.7111764 1.032353 3.7441176 0 1.0317647-1.031765 1.0317647-2.711176 0-3.743529-.5158823-.515883-1.1941176-.774118-1.8717647-.774118z",
    fill: "#c4cdd5",
    opacity: 0.545118
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221.674118 176.021618c-.752353 0-1.505883-.287059-2.079412-.861177l-3.508824-3.508235-3.508823 3.508235c-1.147647 1.148235-3.011177 1.148235-4.158824 0-1.148823-1.148823-1.148823-3.011176 0-4.159412l5.588236-5.588235c1.147647-1.148235 3.011176-1.148235 4.158823 0l5.588235 5.588235c1.148824 1.148824 1.148824 3.011177 0 4.159412-.573529.57353-1.327058.861177-2.079411.861177z",
    fill: "#dfe3e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.2258824 164.815735c-.752353 0-1.5058824-.287059-2.0794118-.861176l-3.50882354-3.508235-3.50882353 3.508235c-1.14764706 1.148235-3.01117647 1.148235-4.15882353 0-1.14882353-1.148824-1.14882353-3.011177 0-4.159412l5.58823529-5.588235c1.14764706-1.148236 3.01117647-1.148236 4.15882351 0l5.5882353 5.588235c1.1488235 1.148824 1.1488235 3.011177 0 4.159412-.5741176.573529-1.3270588.861176-2.0794117.861176z",
    fill: "#d5dbe0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(78 50)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#dfe3e8",
    stroke: "#919eab",
    strokeOpacity: 0.48,
    strokeWidth: 1.5,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m166.960938 0c2.82221 0 5.039062 1.75973333 5.039062 4v36h-172v-36c0-2.24026667 2.21685156-4 5.0390625-4zm-140.960938 15c-2.8003333 0-5 2.1996667-5 5 0 2.7996667 2.1996667 5 5 5s5-2.2003333 5-5c0-2.8003333-2.1996667-5-5-5zm20 0c-2.8003333 0-5 2.1996667-5 5 0 2.7996667 2.1996667 5 5 5s5-2.2003333 5-5c0-2.8003333-2.1996667-5-5-5zm20 0c-2.8003333 0-5 2.1996667-5 5 0 2.7996667 2.1996667 5 5 5s5-2.2003333 5-5c0-2.8003333-2.1996667-5-5-5z",
    fill: "#919eab",
    mask: "url(#c)",
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#919eab",
    strokeDasharray: "2 2",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m146 54h-50c-2.7636667 0-5 2.2363333-5 5v60c0 2.763667 2.2363333 5 5 5h50c2.763667 0 5-2.236333 5-5v-60c0-2.7636667-2.236333-5-5-5z",
    fill: "#919eab",
    fillOpacity: 0.48,
    mask: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 64h20c2.7636667 0 5-2.2363333 5-5s-2.2363333-5-5-5h-20c-2.7636667 0-5 2.2363333-5 5s2.2363333 5 5 5z",
    mask: "url(#c)",
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76 74h-50c-2.7636667 0-5 2.2363333-5 5s2.2363333 5 5 5h50c2.7636667 0 5-2.2363333 5-5s-2.2363333-5-5-5z",
    mask: "url(#c)",
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76 94h-50c-2.7636667 0-5 2.2363333-5 5 0 2.763667 2.2363333 5 5 5h50c2.7636667 0 5-2.236333 5-5 0-2.7636667-2.2363333-5-5-5z",
    mask: "url(#c)",
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76 114h-50c-2.7636667 0-5 2.236333-5 5s2.2363333 5 5 5h50c2.7636667 0 5-2.236333 5-5s-2.2363333-5-5-5z",
    mask: "url(#c)",
    opacity: 0.72
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationEmptyContent);
export default __webpack_public_path__ + "static/media/illustration_empty_content.1426f0947d20d7f35a5cfa22a9ddab55.svg";
export { ForwardRef as ReactComponent };